import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import { IPage, IUser } from 'common/src/types/interfaces';
import {
  ICreateUserDto,
  IUpdateUserDto,
  IUserPasswordRulesDto,
  IUserStatusDto,
} from 'common/src/types/user.dtos';

import { API_BASE_PATHS, formContentType } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getBlobRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getUsersService = async (
  params?: DataQueryParams,
): Promise<IPage<IUser>> =>
  await getRequest(API_BASE_PATHS.USERS, formatQueryParams(params));

export const getUserService = async (id: string): Promise<IUser> =>
  await getRequest(`${API_BASE_PATHS.USERS}/${id}`);

export const getUserStatusService = async (
  id: string,
): Promise<IUserStatusDto> =>
  await getRequest(`${API_BASE_PATHS.USERS}/${id}/status`);

export const getPasswordRulesFromOobCodeService = async (
  oobCode: string,
): Promise<IUserPasswordRulesDto> =>
  await getRequest(`${API_BASE_PATHS.USERS}/password-rules`, { oobCode });

export const addUserService = async (body: ICreateUserDto): Promise<string> =>
  await postRequest(API_BASE_PATHS.USERS, {}, body);

export const updateUserService = async (
  id: string,
  body: IUpdateUserDto,
): Promise<void> =>
  await patchRequest(`${API_BASE_PATHS.USERS}/${id}`, {}, body);

export const getProfilePicture = async (id: string): Promise<Blob> =>
  await getBlobRequest(`${API_BASE_PATHS.USERS}/${id}/profile-picture`);

export const changeProfilePicture = async (
  id: string,
  body: { file: File },
): Promise<void> =>
  await postRequest(
    `${API_BASE_PATHS.USERS}/${id}/profile-picture`,
    {},
    body,
    formContentType,
  );

export const deleteProfilePicture = async (id: string): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.USERS}/${id}/profile-picture`);

export const generateUserApiKey = async (): Promise<string> =>
  await postRequest(`${API_BASE_PATHS.USERS}/api-key`, {}, {});
